















































import { BulletinDeSalaire } from "../../models/BulletinDeSalaire";

export default {
    name: "BulletinDeSalaireModalDisplay",
    props: {
        bulletinDeSalaire: BulletinDeSalaire
    }
};
